export const triggerBlobDownload = ({
  blob,
  filename,
}: {
  blob: Blob;
  filename: string;
}) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};

const utf8ByteOrderMark = "\uFEFF";

// Excel reads a CSV file as the local code page unless it starts with a UTF-8
// byte order mark, so accented names and dashes show as garbled text.
export const withCsvByteOrderMark = (content: string, contentType: string) =>
  /^text\/csv\b/i.test(contentType.trim()) && !content.startsWith(utf8ByteOrderMark)
    ? `${utf8ByteOrderMark}${content}`
    : content;

// excelCompatible is opt-in: accounting and credential CSVs keep their exact
// bytes because import tools were not tested with a byte order mark.
export const downloadTextFile = ({
  content,
  contentType,
  excelCompatible = false,
  filename,
}: {
  content: string;
  contentType: string;
  excelCompatible?: boolean;
  filename: string;
}) => {
  const blob = new Blob(
    [excelCompatible ? withCsvByteOrderMark(content, contentType) : content],
    { type: contentType },
  );
  triggerBlobDownload({ blob, filename });
};

export const downloadBase64File = ({
  base64Data,
  contentType,
  filename,
}: {
  base64Data: string;
  contentType: string;
  filename: string;
}) => {
  const binary = window.atob(base64Data);
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  const blob = new Blob([bytes], { type: contentType });
  triggerBlobDownload({ blob, filename });
};
